`
API 호출 정의, Vuex의 actions에서 사용함.
`;

//API
import axios from "axios";
import router from "@/router";
import store from "@/store";

// http://mapi.school-mom.kr:3000
const DOMAIN = "https://api.schoolt.net/admin";
const UNAUTHORIZED = 401;

const request = (method, url, data) => {
  return axios({
    method: method,
    url: DOMAIN + url,
    data: data,
  })
    .then((result) => result.data)
    .catch((result) => {
      const { status, data } = result.response;

      const jwtExpired =
        data.error === "jwt expired" || data.error === "jwt malformed";

      if (status === UNAUTHORIZED && jwtExpired) {
        store.commit("LOGOUT");
        router.push(`/login`);
      }

      const error = data.error ? { data: data.error } : result.response;

      throw error;
    });
};

export const setAuthInHeader = (token) => {
  axios.defaults.headers.common["Authorization"] = token
    ? `Bearer ${token}`
    : null;
};

export const base = {
  upload(fileData) {
    return axios.post("https://file.school-mom.kr/uploadFile.php", fileData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export const campaign = {
  fetch(id) {
    return id
      ? request("get", `/campaign/${id}`)
      : request("get", "/campaigns");
  },
  create(payload) {
    return request("post", "/campaign", payload);
  },
  update(id, payload) {
    return request("put", `/campaign/${id}`, payload);
  },
  destroy(id) {
    return request("delete", `/campaign/${id}`);
  },

  schedule(date = "2022-03") {
    return request("get", `/campaigns/schedule?year_month=${date}`);
  },
};

export const item = {
  create(payload) {
    return request("post", "/item", payload);
  },
  update(id, payload) {
    return request("put", `/item/${id}`, payload);
  },
  destroy(id) {
    return request("delete", `/item/${id}`);
  },
};

export const user = {
  fetch(id) {
    return id
      ? request("get", `/ksia_member/${id}`)
      : request("get", "/ksia_member");
  },
  create(payload) {
    return request("post", "/ksia_member", payload);
  },
  destroy(id) {
    return request("delete", `/ksia_member/${id}`);
  },
};

export const statistic = {
  fetch(id) {
    return id ? request("get", `/stat/${id}`) : request("get", "/stats");
  },
};

export const auth = {
  login(id, password) {
    return request("post", "/login", { id, password });
  },
};
